export default {"src":"/_next/static/media/fileUpload.4e3bb374.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};